import * as React from "react";
import { useParams } from "react-router-dom";
import { getLayout } from "../auth";
import { useXProps } from "../hooks/useXprops";
import type { AppProps, SetAppProps } from "../types/AppProps";
import boundingBoxOfSpots from "../utils/bbOfSpots";
import { percentDecode } from "../utils/percentEncodingHack";
import { unmapSpots } from "../utils/saveLayoutToApi";
import { saveClassroomID, saveLayoutData } from "../utils/store";

const Edit = (props: AppProps & SetAppProps) => {
  const { setFlow, setName, setOrigin, setRedirect, setSpots } = props;
  let { layout } = useParams<{ layout: string }>();
  layout = percentDecode(layout);

  const { classroomId } = useXProps();

  React.useEffect(() => {
    (async () => {
      const { classroom, name, spots } = await getLayout(layout);
      saveClassroomID(classroomId || classroom.id);

      const unmappedSpots = unmapSpots(spots);
      setFlow(null);
      setName(name);

      const bb = boundingBoxOfSpots(unmappedSpots);
      const windowOffsetX = Math.round(
        (window.innerWidth - bb.width) / 2
      );
      const windowOffsetY = Math.round((window.innerHeight - bb.height) / 2);
      const origin = { x: windowOffsetX, y: windowOffsetY };
      saveLayoutData(name, { spots: unmappedSpots, origin });

      setSpots(unmappedSpots);
      setOrigin(origin);
      setRedirect(`/layout/${encodeURIComponent(name)}?mode=edit`);
    })();
  }, []);
  return <div />;
};

export default Edit;
